<template>
  <div class="allocation-rule-wrap">
    <div class="table-wrap">
      <div class="table-header">
        <span class="header-name">批量规则</span>
        <span class="count-text"
          >已添加账户数量：<span class="count-num">{{ adCount_len }}</span></span
        >
        <el-button type="text" class="edit-btn" @click="showDialog = true"
          ><svg-icon iconClass="edit" className="icon"></svg-icon>编辑</el-button
        >
      </div>
      <div class="header-table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" width="150" label="属性"> </el-table-column>
          <el-table-column prop="num" label="数量"> </el-table-column>
          <el-table-column prop="rule" label="拆分规则"> </el-table-column>
        </el-table>
      </div>
      <div class="header-table-footer">
        预计在<span class="count-num">{{ adCount_len }}</span
        >个账户创建<span class="count-num">{{ formData.projectNum }}</span
        >个项目，<span class="count-num">{{ planNum }}</span
        >个广告
      </div>
    </div>

    <el-dialog title="分配规则" :visible.sync="showDialog" width="500px" :close-on-click-modal="false" top="8vh">
      <div class="dialog-body">
        <ul class="rule-list">
          <li class="rule-item">
            <span class="rule-label">预算与出价：</span>
            <el-radio-group v-model="formData.budget_and_bid" @change="changeRules('budget_and_bid')">
              <el-radio label="adset" :disabled="!!alreadyProjectId">广告</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意组：</span>
            <el-radio-group v-model="formData.creative_groups" @change="changeRules('creative_groups')">
              <el-radio label="adset" :disabled="!!alreadyProjectId">广告</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意标题：</span>
            <el-radio-group v-model="formData.title_group" @change="changeRules('title_group')">
              <el-radio label="adset" :disabled="!!alreadyProjectId">广告</el-radio>
              <!-- <el-radio label="custom">排序分配</el-radio> -->
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">项目数量：</span>
            <el-input-number
              :disabled="!!alreadyProjectId"
              v-model="formData.projectNum"
              controls-position="right"
              :min="1"
              :max="cyz_len"
            ></el-input-number>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleConfirm" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      showDialog: false,
      formData: {
        budget_and_bid: "adset",
        creative_groups: "adset",
        title_group: "adset",
        projectNum: 1,
      },
      planNum: 0,
      timer: null,
    };
  },
  methods: {
    changeRules() {
      // this.$store.commit("set_split_rule_ttV2", {
      //   key: key,
      //   value: this.formData[key],
      // });
      this.computedPlan();
    },
    handleConfirm() {
      this.showDialog = false;
      this.$store.commit("set_all_split_rule_ttV2", this.formData);
    },
    computedPlan() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.planNum = this.ysycj_len * this.cyz_len * this.cybt_len;
      }, 300);
    },
  },
  computed: {
    ...mapState({
      splitRule: (state) => state.PromotionTtV2.splitRule,
      deliverySetting: (state) => state.PromotionTtV2.deliverySetting,
      alreadyProjectId: (state) => state.PromotionTtV2.baseData.projectId,
      adCount_len: (state) => (state.PromotionTtV2.baseData.advertiser_id ? 1 : 0),
      ysycj_len: (state) => {
        let list = state.PromotionTtV2.budgetBids;
        return list ? list.length : 0;
      },
      cyz_len: (state) => {
        let list = state.PromotionTtV2.creative_groups;
        return list ? list.length : 0;
      },
      cybt_len: (state) => {
        let list = state.PromotionTtV2.title_group;
        return list ? list.length : 0;
      },
    }),
    tableData() {
      return [
        {
          name: "预算与出价",
          num: this.ysycj_len,
          rule: this.formData.budget_and_bid === "adset" ? "广告" : this.formData.budget_and_bid === "campaign" ? "项目" : "--",
        },
        {
          name: "创意组",
          num: this.cyz_len,
          rule: this.formData.creative_groups === "adset" ? "广告" : this.formData.creative_groups === "campaign" ? "项目" : "--",
        },
        {
          name: "创意标题",
          num: this.cybt_len,
          rule: this.formData.title_group === "adset" ? "广告" : this.formData.title_group === "campaign" ? "项目" : "--",
        },
      ];
    },
  },
  watch: {
    splitRule: {
      handler(value) {
        if (value) {
          let copyData = JSON.parse(JSON.stringify(value));
          this.formData = copyData;
        }
      },
      deep: true,
    },
    alreadyProjectId(val) {
      if (val) {
        this.formData.projectNum = 1;
      }
      this.$store.commit("set_all_split_rule_ttV2", this.formData);
    },
    adCount_len() {
      this.computedPlan();
    },
    rqb_len() {
      this.computedPlan();
    },
    dxb_len() {
      this.computedPlan();
    },
    ysycj_len() {
      this.computedPlan();
    },
    cyz_len() {
      this.computedPlan();
    },
    cybt_len() {
      this.computedPlan();
    },
  },
};
</script>

<style lang="less" scoped>
.allocation-rule-wrap {
  .table-wrap {
    width: 100%;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    box-sizing: border-box;
    .table-header {
      display: flex;
      align-items: flex-end;
      .header-name {
        color: rgba(0, 0, 0, 1);
        font-weight: 500;
        font-size: 16px;
        font-weight: bold;
      }
      .count-text {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        line-height: 15px;
        margin-left: 12px;
        .count-num {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
        }
      }
      .edit-btn {
        margin-left: auto;
        color: rgba(24, 144, 255, 1);
        padding: 0px;
        .icon {
          margin-right: 4px;
        }
      }
    }
    .header-table-wrap {
      margin-top: 24px;
      /deep/ th {
        height: 30px;
      }
      /deep/ .el-table__cell {
        padding: 5px 0;
      }
    }
    .header-table-footer {
      padding-top: 10px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      .count-num {
        margin: 0 4px;
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
      }
    }
  }
  .dialog-body {
    .rule-list {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .rule-item {
        margin-top: 20px;
        .rule-label {
          display: inline-block;
          width: 180px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          text-align: right;
          padding-right: 2px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
